module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("This book is dedicated to the memory of Amber.")]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_vm._v("“And some there be, which have no memorial.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-751694c7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/section3.vue
// module id = 81
// module chunks = 0